import { create } from 'zustand'

export const isMobile = () => {
    return window.innerWidth < 840;
}

export const ifMobile = (ifMobileString: string, ifDesktopString: string) => {
    return isMobile() ? ifMobileString : ifDesktopString;
}

interface MenuStoreState {
    menuOpened: boolean;
    setMenuOpened: (opened: boolean) => void;
}


export const useMenuStore = create<MenuStoreState>((set) => ({
    menuOpened: !isMobile(),
    setMenuOpened: (opened: boolean) => set({ menuOpened: opened }),
}));

export const canShowContent = () => {
    return !useMenuStore.getState().menuOpened || !isMobile();
}

export const onMenuNavigate = () => {
    if (isMobile()) useMenuStore.getState().setMenuOpened(false);
};

export const menuIsBlockingContent = () => {
    return useMenuStore.getState().menuOpened && isMobile()
}